import React, { useMemo } from 'react';
import { Filter } from 'lucide-react';
import { Modal } from '../../components/ui/Modal';
import SelectDropdown from '../../components/ui/SelectDropdown';
import { emptyMemberFilter } from './useMembersTableState';

export default function MembersFilterModal({
  isOpen,
  onClose,
  draftFilter,
  setDraftFilter,
  streamOptions,
  projectOptions,
  orgRepositories,
  onApply,
}: any) {
  const repoOptionsForDraft = useMemo(() => {
    if (!draftFilter.projectId) return [];
    return orgRepositories.filter((r) => r.projectId === draftFilter.projectId);
  }, [orgRepositories, draftFilter.projectId]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Filter members"
      icon={<Filter className="w-5 h-5 text-vivid-red" />}
      contentClassName="max-w-md"
    >
      <div className="space-y-4 border-b border-dark-border pb-4">
        <div>
          <label
            htmlFor="member-filter-stream"
            className="block text-sm font-medium text-slate-300 mb-1"
          >
            Stream
          </label>
          <SelectDropdown
            id="member-filter-stream"
            className="w-full"
            value={draftFilter.streamId}
            onChange={(v) => {
              setDraftFilter((d) => ({ ...d, streamId: v, projectId: '', repositoryId: '' }));
            }}
            options={[
              { value: '', label: 'Any stream' },
              ...streamOptions.map((s) => ({ value: s.id, label: s.name || s.id })),
            ]}
          />
        </div>
        <div>
          <label
            htmlFor="member-filter-project"
            className="block text-sm font-medium text-slate-300 mb-1"
          >
            Project
          </label>
          <SelectDropdown
            id="member-filter-project"
            className="w-full"
            value={draftFilter.projectId}
            onChange={(v) => {
              setDraftFilter((d) => ({ ...d, projectId: v, repositoryId: '' }));
            }}
            disabled={!draftFilter.streamId}
            options={[
              { value: '', label: 'Any project' },
              ...projectOptions.map((p) => ({ value: p.id, label: p.name || p.slug || p.id })),
            ]}
          />
        </div>
        <div>
          <label
            htmlFor="member-filter-repo"
            className="block text-sm font-medium text-slate-300 mb-1"
          >
            Repository
          </label>
          <SelectDropdown
            id="member-filter-repo"
            className="w-full"
            value={draftFilter.repositoryId}
            onChange={(v) => setDraftFilter((d) => ({ ...d, repositoryId: v }))}
            disabled={!draftFilter.projectId}
            options={[
              { value: '', label: 'Any repository' },
              ...repoOptionsForDraft.map((r) => ({
                value: r.id,
                label: r.fullName || r.name || r.id,
              })),
            ]}
          />
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-end gap-2 pt-4">
        <button
          type="button"
          onClick={() => setDraftFilter(emptyMemberFilter())}
          className="btn-secondary-mdl text-sm"
        >
          Clear
        </button>
        <button type="button" onClick={onApply} className="btn-primary-mdl text-sm">
          Apply
        </button>
      </div>
    </Modal>
  );
}
